<button pButton
        type="button"
        icon="pi pi-upload"
        label="Créer des projets en lot"
        class="p-button-outlined mr-2 mb-2"
        (click)="open()"></button>

<p-dialog header="Créer des projets en lot"
          [modal]="true"
          [(visible)]="displayDialog"
          [style]="{width: '60vw'}"
          styleClass="bulk-create-dialog"
          (onHide)="close()">

  <p-message *ngIf="globalError" severity="error" [text]="globalError" class="block mb-3"></p-message>

  <ng-container *ngIf="step === 'import'">
    <div class="flex align-items-center gap-2 mb-3">
      <label for="bulkCsvFile" class="font-bold">Importer un fichier CSV</label>
      <button pButton
              type="button"
              icon="pi pi-question-circle"
              class="p-button-rounded p-button-text"
              title="Afficher le format attendu"
              (click)="toggleFormatHelp()"></button>
    </div>

    <div class="bulk-format-help" *ngIf="showFormatHelp">
      <p>Fichier CSV sans en-tête, 2 colonnes séparées par <code>;</code> :</p>
      <pre>9782700000001;PRJ-2026-001
9782700000002;PRJ-2026-002</pre>
      <ul>
        <li>EAN : 13 chiffres</li>
        <li>Code projet : alphanumérique, "-" autorisé</li>
      </ul>
    </div>

    <div class="flex align-items-center gap-2">
      <input #csvFileInput
             id="bulkCsvFile"
             class="hidden-file-input"
             type="file"
             accept=".csv,text/csv"
             (change)="onFileSelected($event)">
      <button pButton
              type="button"
              icon="pi pi-upload"
              label="Choisir un fichier CSV"
              class="p-button-outlined"
              (click)="csvFileInput.click()"></button>
      <span *ngIf="loading">Analyse du fichier en cours...</span>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 'review'">
    <p-table [value]="reviewRows" [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>EAN</th>
          <th>Titre web</th>
          <th>Code projet</th>
          <th>Ouvrage réforme</th>
          <th>Statut</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.ean }}</td>
          <td>{{ row.titreWeb }}</td>
          <td>{{ row.codeProjet }}</td>
          <td>
            <input type="checkbox" [(ngModel)]="row.ouvrageReforme" [disabled]="!row.valid">
          </td>
          <td>
            <span class="bulk-status-badge"
                  [ngClass]="row.valid ? 'bulk-status-badge-ok' : 'bulk-status-badge-error'">
              {{ row.valid ? 'Prêt pour création' : row.errorMessage }}
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="mt-3 flex gap-2">
      <button pButton
              type="button"
              label="Valider et créer les projets"
              [disabled]="validRowsCount === 0 || loading"
              (click)="onValidate()"></button>
      <button pButton
              type="button"
              label="Réimporter un autre fichier"
              class="p-button-outlined"
              [disabled]="loading"
              (click)="reimport()"></button>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 'result'">
    <p-message severity="success"
               [text]="finalSuccessCount + '/' + finalTotalCount + ' projets créés avec succès.'"
               class="block mb-3"></p-message>

    <ng-container *ngIf="failedRows.length > 0">
      <p class="font-bold mb-2">Détail des lignes non créées :</p>
      <p-table [value]="failedRows" [tableStyle]="{ 'min-width': '30rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>EAN</th>
            <th>Code projet</th>
            <th>Erreur</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.ean }}</td>
            <td>{{ row.codeProjet }}</td>
            <td>
              <span class="bulk-status-badge bulk-status-badge-error">{{ row.errorMessage }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>

    <div class="mt-3 flex gap-2">
      <button pButton
              type="button"
              label="Importer un nouveau lot"
              class="p-button-outlined"
              (click)="reimport()"></button>
      <button pButton
              type="button"
              label="Fermer"
              (click)="close()"></button>
    </div>
  </ng-container>

</p-dialog>
